import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function HeroSection() {
  return <Section className="pt-12 pb-20 md:pt-20" data-id="element-72">
      <div className="text-center mb-8" data-id="element-73">
        <p className="text-amber-500 font-medium tracking-wide uppercase text-sm mb-4" data-id="element-74">
          Para mujeres 65+ que se despiertan entre las 2 y las 5AM
        </p>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-cream-50 leading-tight mb-8" data-id="element-75">
          Qué hacer a las 3AM <br data-id="element-76" />
          <span className="italic font-normal text-amber-500" data-id="element-77">
            (sin pensar)
          </span>
        </h1>
      </div>

      <div className="mb-10 rounded-xl overflow-hidden shadow-2xl shadow-amber-900/20 border border-warm-700" data-id="element-78">
        <img src="https://cdn.magicpatterns.com/uploads/g5QjRm2XMrqhighnDKYWPN/3_AM_otra_vez.png" alt="3AM otra vez Kit Anti-Despertar Nocturno en una mesa de noche con luz cálida" className="w-full h-auto object-cover" data-id="element-79" />
      </div>

      <div className="space-y-6 text-lg md:text-xl text-cream-100 leading-relaxed font-light" data-id="element-80">
        <p data-id="element-81">A veces no es el cansancio lo peor.</p>
        <p data-id="element-82">
          Es ese momento en que abres los ojos, sientes el calor en la piel… y
          piensas:
        </p>
        <p className="italic text-cream-50 font-serif text-2xl border-l-4 border-amber-500 pl-4 py-2 my-6 bg-warm-800/50 rounded-r-lg" data-id="element-83">
          "No… otra vez no."
        </p>
        <p data-id="element-84">
          Porque ya sabes cómo termina: te mueves, te destapas, te vuelves a
          tapar…
        </p>
        <p data-id="element-85">y tu mente se prende como si fueran las 10 de la mañana.</p>
        <p data-id="element-86">Este no es otro ebook de "higiene del sueño".</p>
        <p className="font-medium text-amber-500" data-id="element-87">
          Es un plan para el momento exacto en que te despiertas entre las 2 y
          las 5am.
        </p>
      </div>

      <div className="mt-10 text-center" data-id="element-88">
        <Button scrollTo="pricing" fullWidth className="md:w-auto md:px-12" data-id="element-89">
          Ver el Protocolo BVV
        </Button>
      </div>
    </Section>;
}